// AcknowledgementMessageDialog - MODULE
// ***********************************************************************************************************************
import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import * as store from "../../framework/customStore";
import * as baseService from "../../services/baseService";
import * as storeActions from "../../models/store/storeActions";
import * as acknowledgementService from "../../services/acknowledgementService";
import { Dialog } from "../framework/dialog";
import { Base } from "../../framework/base";
import { SaveData } from "../../framework/saveData";

// AcknowledgementMessageDialog
// ***********************************************************************************************************************
export interface IAcknowledgementMessageDialogProp {
    classes?: string;
    acknowledgementId: string;
    workOrderNumber: number;
    workOrderDescription: string;
    onOk: () => void;
    onCancel: () => void;
}

const getSaveData = (
    props: IAcknowledgementMessageDialogProp,
    subject: string,
    body: string
): SaveData => {
    const data = new SaveData();
    data.append("workOrderAcknowledgementId", props.acknowledgementId);
    data.append("subject", subject);
    data.append("body", body);
    return data;
};

export const AcknowledgementMessageDialog = (
    props: IAcknowledgementMessageDialogProp
) => {
    const { t } = useTranslation();
    const [subject, setSubject] = useState(
        t("workOrder.workOrder") +
            " " +
            props.workOrderNumber.toString(10) +
            " " +
            props.workOrderDescription
    );
    const [body, setBody] = useState("");

    const handleChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = event.target;
        if (name === "subject") {
            setSubject(value);
        } else if (name === "body") {
            setBody(value);
        }
    };

    const handleOkClick = () => {
        if (!subject) {
            store.customStore.dispatch(
                storeActions.showErrorMessage(t("message.subjectMustBeDefined"))
            );
            return;
        }
        if (!body) {
            store.customStore.dispatch(
                storeActions.showErrorMessage(t("message.contentMustBeDefined"))
            );
            return;
        }
        const saveData = getSaveData(props, subject, body);
        if (Base.isNullOrUndefined(saveData)) return;
        store.customStore.dispatch(storeActions.fetchStart());
        acknowledgementService
            .sendMessage(saveData.formData)
            .then((success) => {
                store.customStore.dispatch(
                    storeActions.showSuccessMessage(success.message)
                );
                props.onOk();
            })
            .catch((error) => {
                store.customStore.dispatch(
                    storeActions.showErrorMessage(
                        baseService.getErrorMessageFromError(error)
                    )
                );
            })
            .finally(() => store.customStore.dispatch(storeActions.fetchEnd()));
    };

    const dialogClasses =
        "acknowledgementMessage px600" +
        (props.classes ? " " + props.classes : "");
    return (
        <div>
            <Dialog
                classes={dialogClasses}
                title={t("common.sendMessage")}
                show={true}
                body={
                    <div>
                        <div className="form-group required">
                            <label className="control-label smallFont">
                                {t("message.subject")}
                            </label>
                            <input
                                type="text"
                                className="form-control"
                                name="subject"
                                title={t("message.subject")}
                                value={subject}
                                onChange={handleChange}
                            />
                        </div>
                        <div className="form-group required">
                            <label className="control-label smallFont">
                                {t("message.content")}
                            </label>
                            <textarea
                                className="form-control"
                                name="body"
                                title={t("message.content")}
                                value={body}
                                onChange={handleChange}
                                maxLength={5000}
                            />
                        </div>
                    </div>
                }
                buttons={[
                    {
                        title: t("common.send"),
                        classes: "btn-primary",
                        enabled: true,
                        onClick: handleOkClick,
                    },
                ]}
                onClose={props.onCancel}
            />
        </div>
    );
};
